import { UswErrorFill } from '@uswitch/spark-icons/usw'
import { Alert } from '@uswitch/spark.alert'
import { Input } from '@uswitch/spark.input'
import { useState } from 'react'

const emailRegex =
  // eslint-disable-next-line no-control-regex, no-useless-escape
  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i

export const isEmailValid = (email) => emailRegex.test(email)

export const ConsentEmailInput = ({ emailAddress, isEmailValid, onChange }) => {
  const [isInputOnBlur, setIsInputOnBlur] = useState(false)

  return (
    <div
      sx={{
        display: 'flex',
        borderRadius: '8px',
        justifyContent: 'space-between',
        flexDirection: ['column', 'column', 'row']
      }}
    >
      <div sx={{ width: '100%' }}>
        <Input
          id='email-address-input'
          onBlur={() => {
            setIsInputOnBlur(true)
          }}
          value={emailAddress}
          placeholder='Email address'
          isError={!isEmailValid && emailAddress !== ''}
          autoComplete='email'
          onChangeHandler={(event) => {
            onChange(event.target.value)
          }}
          type='email'
        />

        {isInputOnBlur === true && emailAddress !== '' && isEmailValid === false && (
          <Alert variant='error' sx={{ marginTop: 'sm' }}>
            <UswErrorFill size='21' /> Please enter an email in the correct format, like name@example.com
          </Alert>
        )}
      </div>
    </div>
  )
}
